import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "366.667",
  height: "526.667",
  version: "1.0",
  viewBox: "0 0 275 395"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M79.7 65.8 15 130.5l16.9 16.9 16.8 16.8 36.2-36.4L121 91.5l-.3 127.5-.2 127.5-59.7.3L1 347v47h168V92.5l35.8 35.8 35.7 35.7 17-17 17-17L210 65.5C174.5 30 145.3 1 145 1s-29.6 29.1-65.3 64.8" }, null, -1)
  ]))]))
}
export default { render: render }